module.exports = __webpack_public_path__ + "img/jh.8cf47c2b.png";